/* eslint-disable @fx-ui/jdy-design/limit-specific-characters */
import { LocaleRecord } from '~/interfaces/locale';
import { IntlClass, LOCALE_KEY } from '@fx-ui/intl';
import type HelpSourceType from '~/locales/help-source/jdy_zh_cn.json';
import { HOST } from './common';

export const LANG: LocaleRecord<string> = {
    [LOCALE_KEY.ZH_CN]: '简体中文',
    [LOCALE_KEY.ZH_TW]: '繁體中文',
    [LOCALE_KEY.EN_US]: 'English',
    [LOCALE_KEY.JA_JP]: '日本語',
    [LOCALE_KEY.VI_VN]: 'Tiếng Việt',
    [LOCALE_KEY.RU_RU]: 'Русский',
    [LOCALE_KEY.FR_FR]: 'Français',
    [LOCALE_KEY.ES_ES]: 'Español',
    [LOCALE_KEY.TH_TH]: 'ไทย',
    [LOCALE_KEY.ID_ID]: 'Bahasa Indonesia',
    [LOCALE_KEY.KO_KR]: '한국어',
    [LOCALE_KEY.DE_DE]: 'Deutsch',
    [LOCALE_KEY.PT_PT]: 'Português',
    [LOCALE_KEY.KM_KH]: 'ភាសាខ្មែរ',
    [LOCALE_KEY.LO_LA]: 'ລາວ',
    [LOCALE_KEY.HI_IN]: 'हिन्दी',
    [LOCALE_KEY.BN_BD]: 'বাংলা',
    [LOCALE_KEY.TA_IN]: 'தமிழ்',
    [LOCALE_KEY.UZ_UZ]: 'Oʻzbekcha',
    [LOCALE_KEY.MN_MN]: 'Монгол',
    [LOCALE_KEY.IT_IT]: 'Italiano',
    [LOCALE_KEY.NL_NL]: 'Nederlands',
    [LOCALE_KEY.PL_PL]: 'Polski',
    [LOCALE_KEY.HU_HU]: 'Magyar',
    [LOCALE_KEY.PT_BR]: 'Português (Brasil)'
};

export const helpSourceIntl = new IntlClass<keyof typeof HelpSourceType>();
// 设置默认的help文档地址，用于兜底没有文档的情况
helpSourceIntl.setDefaultValues({
    defaultMessage: HOST.HELP_HOST
});

export const imageSourceIntl = new IntlClass();
